import { render, staticRenderFns } from "./WidgetStaticMap.vue?vue&type=template&id=81f251ac&scoped=true&"
import script from "./WidgetStaticMap.vue?vue&type=script&lang=js&"
export * from "./WidgetStaticMap.vue?vue&type=script&lang=js&"
import style0 from "./WidgetStaticMap.vue?vue&type=style&index=0&id=81f251ac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81f251ac",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/vhosts/dostartu.pl/app.startzone.online/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('81f251ac')) {
      api.createRecord('81f251ac', component.options)
    } else {
      api.reload('81f251ac', component.options)
    }
    module.hot.accept("./WidgetStaticMap.vue?vue&type=template&id=81f251ac&scoped=true&", function () {
      api.rerender('81f251ac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/WidgetStaticMap.vue"
export default component.exports